/*
 * Scenario: insert-after-cursor
 *
 * Schlaegt einen neuen Absatz nach dem aktuellen Cursor-Paragraph vor.
 * Demonstriert die Insert-Vorschau (virtuelle Zeile zwischen den echten
 * Paragraphen) und das `+`-Marker-Glyph am linken Rand.
 */

import { emit, wait, resolve } from './_helpers.js'

export const name = 'insert-after-cursor'
export const description = 'Insert a new paragraph after the cursor.'

export async function run(state) {
    const toolCallId = 'tu_ins_' + Date.now().toString(36)

    await emit(state, 'session', { sessionId: 'mock-insert' }, 0)
    await emit(state, 'thinking', { text: 'Let me add a transition paragraph here…' }, 250)
    await emit(state, 'thinkingDone', {}, 200)

    const afterParagraphId = resolve(state, '$cursor.paragraphId')
    const baseVersion = resolve(state, '$cursor.version')

    await emit(state, 'proposeInsert', {
        toolCallId,
        afterParagraphId,
        baseVersion: typeof baseVersion === 'number' ? baseVersion : undefined,
        newText: 'A heavy silence settled between them. Outside, the wind picked up — the first warning of the storm that would change everything.',
        reason: 'Bridges the previous paragraph to the next scene.'
    }, 400)
    await emit(state, 'done', { usage: {} }, 200)

    try {
        const info = await wait(state, toolCallId, 5 * 60 * 1000)
        const reaction = info.result === 'applied'
            ? 'Added the transition. Want me to look at the next break?'
            : 'No problem. I will leave it for you.'
        await emit(state, 'delta', { text: reaction }, 300)
        await emit(state, 'done', { usage: {} }, 100)
    } catch { /* abort */ }
}
